import { IThunderboltEntry } from '@wix/editor-elements-types';

const entry: IThunderboltEntry = {
  loadComponent: hostAPI => {
    hostAPI.registerComponent('AudioPlayer', () => {
      return import(
        './viewer/AudioPlayer' /* webpackChunkName: "AudioPlayer" */
      ).then(componentModule => {
        return {
          component: componentModule.default,
        };
      });
    });

    hostAPI.registerComponent(
      'AudioPlayer',
      () => {
        return import(
          './viewer/skinComps/SimplePlayer/SimplePlayer.skin' /* webpackChunkName: "AudioPlayer_SimplePlayer" */
        ).then(componentModule => {
          return {
            component: componentModule.default,
          };
        });
      },
      'SimplePlayer',
    );

    hostAPI.registerComponent(
      'AudioPlayer',
      () => {
        return import(
          './viewer/skinComps/ShinyPlayer/ShinyPlayer.skin' /* webpackChunkName: "AudioPlayer_ShinyPlayer" */
        ).then(componentModule => {
          return {
            component: componentModule.default,
          };
        });
      },
      'ShinyPlayer',
    );

    hostAPI.registerComponent(
      'AudioPlayer',
      () => {
        return import(
          './viewer/skinComps/BoldPlayer/BoldPlayer.skin' /* webpackChunkName: "AudioPlayer_BoldPlayer" */
        ).then(componentModule => {
          return {
            component: componentModule.default,
          };
        });
      },
      'BoldPlayer',
    );

    hostAPI.registerComponent(
      'AudioPlayer',
      () => {
        return import(
          './viewer/skinComps/Audio3DPlayer/Audio3DPlayer.skin' /* webpackChunkName: "AudioPlayer_Audio3DPlayer" */
        ).then(componentModule => {
          return {
            component: componentModule.default,
          };
        });
      },
      'Audio3DPlayer',
    );
  },
};

export default entry;
